import { ref, computed } from "vue"; 
import { defineStore } from "pinia";


export const useUserDataStore = defineStore("UserDataStore", () => {

  const isLoading = ref([] as Array<boolean>); 

  const showLoading = computed(() => isLoading.value.length > 0);

  function setLoading(val: boolean) {
    val ? isLoading.value.push(true) : isLoading.value.pop();
  }

  return {
    isLoading,
    showLoading,
    setLoading
 
  };
});